import * as React from 'react'
import { FormattedMessage } from 'react-intl'

import { useMediaQuery } from '@gto/ui/hooks/use-media-query'
import { Typography } from '@gto/ui/typography'

import { useSiteSettings } from '@/hooks/use-site-settings'
import terms from '@/pages/legal/assets/terms.md?raw'
import { MarkdownWrapper } from '@/pages/legal/components/markdown-wrapper'

export const TermsRoute = () => {
  const isSmAndLower = useMediaQuery('down', 'sm')
  const { settings } = useSiteSettings()

  const processedTerms = React.useMemo(() => {
    if (typeof settings?.contact_email === 'string' && settings.contact_email.length > 0) {
      return terms.replace(/{{contact_email}}/g, settings.contact_email)
    }

    // If no email is set in admin, remove the placeholder links entirely.
    return terms.replace(/\[{{contact_email}}\]\(mailto:{{contact_email}}\)/g, '')
  }, [settings])

  return (
    <div className="flex flex-col gap-8 sm:gap-6">
      <Typography
        gutterBottom
        component="h1"
        variant={isSmAndLower ? 'h5' : 'h4'}
      >
        <FormattedMessage id="common.controls.termsOfService" />
      </Typography>

      <MarkdownWrapper markdown={processedTerms} />
    </div>
  )
}
